import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 auto 24px;
  max-width: 980px;
`;

export const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 28px;

  div {
    display: flex;
    gap: 8px;
  }

  a {
    background: var(--aurea);
    border: 1px solid var(--aurea);
    border-radius: 5px;
    color: var(--dark);
    font-weight: bold;
    padding: 8px 14px;

    &.secondary {
      background: #fff;
      border-color: var(--gray-border);
    }

    &:hover {
      text-decoration: none;
    }
  }
`;

export const Filters = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 20px;

  input,
  select {
    background: #fff;
    border: 1px solid var(--gray-border);
    border-radius: 5px;
    color: var(--dark);
    min-height: 42px;
    padding: 8px 12px;
  }

  input {
    flex: 1;
  }
`;

export const ResourceTable = styled.div`
  background: #fff;
  border: 1px solid var(--gray-border);
  border-radius: 5px;
  overflow: hidden;

  table {
    border-collapse: collapse;
    width: 100%;
  }

  th,
  td {
    border-bottom: 1px solid var(--gray-border);
    padding: 14px 16px;
    text-align: left;
  }

  th {
    color: var(--gray);
    font-size: 0.8rem;
    text-transform: uppercase;
  }

  tbody tr:last-child td {
    border-bottom: 0;
  }

  .empty {
    padding: 36px;
    text-align: center;
  }
`;

export const Status = styled.span`
  background: #ddd;
  border-radius: 14px;
  display: inline-block;
  font-size: 0.8rem;
  padding: 4px 10px;

  &.publish {
    background: var(--success);
    color: #fff;
  }
`;

export const Pagination = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;

  span {
    color: var(--gray);
    margin: 0 12px;
  }

  button {
    background: #fff;
    border: 1px solid var(--gray-border);
    border-radius: 5px;
    padding: 8px 12px;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
`;

export const FormCard = styled.form`
  background: #fff;
  border: 1px solid var(--gray-border);
  border-radius: 5px;
  padding: 24px;

  .row {
    display: flex;
    gap: 16px;

    > label {
      flex: 1;
    }
  }

  label {
    color: var(--gray);
    display: block;
    font-weight: bold;
    margin-bottom: 16px;
  }

  input,
  select,
  textarea {
    background: #fff;
    border: 1px solid var(--gray-border);
    border-radius: 5px;
    display: block;
    margin-top: 6px;
    min-height: 42px;
    padding: 9px 12px;
    width: 100%;
  }

  textarea {
    min-height: 90px;
    resize: vertical;
  }

  .upload {
    margin-bottom: 18px;
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
  }

  .actions button {
    background: var(--aurea);
    border: 1px solid var(--aurea);
    border-radius: 5px;
    font-weight: bold;
    padding: 10px 22px;

    &:disabled {
      cursor: wait;
      opacity: 0.7;
    }
  }
`;
